import { logDebug, logError, logWarning } from '@/lib/logging-utils';

type LogPayload = Record<string, unknown> | undefined;

type LogMethod = (message: string, payload?: LogPayload) => void;

interface TweetMediaLogger {
  debug: LogMethod;
  error: LogMethod;
  warn: LogMethod;
}

function createTweetMediaLogger(): TweetMediaLogger {
  const tag = 'ui';

  return {
    debug: (message, payload) => {
      logDebug(message, payload, tag);
    },
    warn: (message, payload) => {
      logWarning(message, payload, tag);
    },
    error: (message, payload) => {
      logError(message, payload, tag);
    },
  };
}

export const mediaLogger = createTweetMediaLogger();
